module.exports = __webpack_public_path__ + "static/media/using-mindjjo-for.79c458ac.svg";